import { FieldErrorMessage } from "../others"
import { useEffect, useRef } from "react"
import { useTranslation } from 'react-i18next';
import { InfoBubble } from "../others";

const InputProfile = ({ 
    formikProps,
    type,
    text, 
    name, 
    placeholder,
    maxLength,
    disabled = false,
    multiline = false,
    maxHeight = 128,
    onUnlink = null,
    unlinkLoading = null,
    integration = null,
    infoBubble = null,
    infoBubbleWidth = 256
}) => {
    const { t } = useTranslation();
    const textareaRef = useRef(null);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto";  // Reset height
            textarea.style.height = `${5+textarea.scrollHeight}px`; // Max height of 8 rows (128px)
        }
    };

    useEffect(() => {
        if (multiline) {
            adjustTextareaHeight();
        }
    }, [formikProps.values[name], multiline]);

    return (
        <div>
            {integration ||  infoBubble ? 
                <div className="flex justify-between items-center">
                    <label
                        htmlFor={name}
                        className="mb-2 block text-sm font-medium leading-6 text-gray-900"
                    >
                        {text}
                    </label>
                    {integration &&
                        <a
                            href={integration.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 text-sm hover:underline"
                        >
                            {t('get-api-key', 'Obtenir la clé API')}
                        </a>
                    }
                    {infoBubble &&
                        <InfoBubble placement="top-center" text={infoBubble} width={infoBubbleWidth}/>
                    }
                </div>
                :
                <label
                    htmlFor={name}
                    className="mb-2 block text-sm font-medium leading-6 text-gray-900"
                >
                    {text}
                </label>
            }
            {multiline ? (
                <textarea
                    ref={textareaRef}
                    className="w-full bg-white p-2.5 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 resize-none overflow-y-auto disabled:bg-slate-200 disabled:text-slate-400"
                    placeholder={placeholder}
                    value={formikProps.values[name]}
                    onChange={(e) => {
                        formikProps.handleChange(e);
                        adjustTextareaHeight();
                    }}
                    onBlur={formikProps.handleBlur}
                    name={name}
                    disabled={disabled}
                    rows={2}
                    style={{ maxHeight: `${maxHeight}px` }}
                    maxLength={maxLength}
                />
            ) : (
                // Render input if multiline is false
                (integration ? 
                    <div className="relative">
                        <input
                            className="w-full bg-white p-2.5 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 h-fit overflow-hidden disabled:bg-slate-200 disabled:text-slate-400"
                            type={type}
                            placeholder={placeholder}
                            value={formikProps.values[name]}
                            onChange={formikProps.handleChange}
                            onBlur={formikProps.handleBlur}
                            name={name}
                            disabled={disabled}
                            maxLength={maxLength}
                        />

                        {integration.apiKey && (
                            <button
                            type="button"
                            className="absolute right-1 top-1/2 -translate-y-1/2 flex items-center justify-center text-black hover:text-black/60"
                            onClick={() => onUnlink(integration)}
                            disabled={unlinkLoading}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 50 50"
                                    fill="currentColor"
                                    className="w-7 h-7"
                                >
                                    <path d="M25 38c-5.1 0-9.7-3-11.8-7.6l1.8-.8c1.8 3.9 5.7 6.4 10 6.4 6.1 0 11-4.9 11-11s-4.9-11-11-11c-4.6 0-8.5 2.8-10.1 7.3l-1.9-.7c1.9-5.2 6.6-8.6 12-8.6 7.2 0 13 5.8 13 13s-5.8 13-13 13z"/>
                                    <path d="M20 22h-8v-8h2v6h6z"/>
                                </svg>
                            </button>
                        )}
                    </div>
                    :
                    <input
                        className="w-full bg-white p-2.5 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 h-fit overflow-hidden disabled:bg-slate-200 disabled:text-slate-400"
                        type={type}
                        placeholder={placeholder}
                        value={formikProps.values[name]}
                        onChange={formikProps.handleChange}
                        onBlur={formikProps.handleBlur}
                        name={name}
                        disabled={disabled}
                        maxLength={maxLength}
                    />
                )
            )}
            <div className="flex justify-between items-center text-xs">
                <FieldErrorMessage name={name} />
                {maxLength && (
                    <div className="text-gray-500">
                        {formikProps.values[name]?.length} / {maxLength}
                    </div>
                )}
            </div>
        </div>
    )
}

export default InputProfile;